(function () {
  function findPicker(formId) {
    if (!formId) return null;
    // 1. Picker's own form-id attribute
    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
    if (picker) return picker;
    // 2. Any input bound to that form, then walk up to its picker
    var input = document.querySelector('[form="' + formId + '"]');
    if (input && input.closest) {
      picker = input.closest('variant-picker');
      if (picker) return picker;
    }
    // 3. Walk up from the form itself
    var el = document.getElementById(formId);
    while (el && el !== document.body) {
      var found = el.querySelector && el.querySelector('variant-picker');
      if (found) return found;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    if (!detail.variant) return;

    var picker = findPicker(detail.formId);
    if (!picker) return;

    var id = String(detail.variant.id);
    picker.querySelectorAll('[data-hc-variant]').forEach(function (el) {
      el.hidden = el.getAttribute('data-hc-variant') !== id;
    });
  });
})();


